import { _axios } from "../../../Utils/Axios/axios";
export const addCommentToTeachItemService = async (
  userToken: string,
  sectionId: string,
  commentText: string
) => {
  const data = new FormData();

  data.append("text", commentText);
  data.append("section_id", sectionId);

  return _axios.post("/comment", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
